import { Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';

export function PreferencesPage(): ReactElement {
  return (
    <BrandSidebarWithHeader fullWidth={true}>
      <Outlet />
    </BrandSidebarWithHeader>
  );
}
